// global
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Route, Switch } from 'react-router';
import { Progress } from 'semantic-ui-react';
import _ from 'lodash';
// local
// views
import MainMenu from './MainMenu';
import HomeHeader from './HomeHeader';
import ScrollToTop from 'app/ui/commons/ScrollToTop';
// actions
import { loginWithToken } from 'app/redux/actions/auth';
// storage
import { getToken } from 'app/storage/auth';
// css
import './Home.css';
// routes config
import { getRoutes } from './routes';
class Home extends Component {
    componentDidMount() {
        const { isAuthenticated, account } = this.props.auth;
        if (isAuthenticated && !account) {
            this.props.dispatch(loginWithToken(getToken()));
        }
    }

    render() {
        const { loadingByToken, loading, account } = this.props.auth;

        if (!account || loading || loadingByToken) {
            return <Progress size="tiny" percent={100} color="teal" indicating />;
        }

        return (
            <div id="page-home">
                <MainMenu account={account} />
                <div id="home-body">
                    <HomeHeader />
                    <ScrollToTop />
                    <div id="home-content">
                        <Switch>
                            {_.map(getRoutes(account), route => <Route key={`route-${route.path}`} exact={route.exact} path={route.path} component={route.component} />)}
                        </Switch>
                    </div>
                </div>
            </div>
        );
    }
}

Home.propTypes = {
    auth: PropTypes.object,
    dispatch: PropTypes.func,
};

const mapStateToProps = state => ({
    auth: state.auth,
});
export default connect(mapStateToProps)(Home);
